var render, staticRenderFns
import script from "./InputColumn.vue?vue&type=script&lang=js&"
export * from "./InputColumn.vue?vue&type=script&lang=js&"
import style0 from "./InputColumn.vue?vue&type=style&index=0&id=38200bc2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38200bc2",
  null
  
)

export default component.exports